"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../../../hooks");
var _CetComponentsProvider = require("../../../../../../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    view = 'default'
  } = props;
  const ccItemTypeStyle = (0, _react.useMemo)(() => {
    const viewProps = () => {
      if (view === 'horizontal') {
        return {
          display: 'inline-block',
          fontWeight: 'bold',
          margin: `0 ${pxToRem(5)}`,
          '&:first-child': {
            marginInlineStart: 0
          },
          '&::after': {
            content: '",\u00a0"'
          },
          '&:last-child::after': {
            content: '""'
          }
        };
      }
      return {
        height: pxToRem(17),
        borderRadius: pxToRem(16),
        background: 'rgba(0, 0, 0, 0.4)',
        color: themeColors?.general.light,
        padding: `0 ${pxToRem(7)}`,
        margin: `${pxToRem(3)} ${pxToRem(5)} 0`,
        fontSize: pxToRem(13)
      };
    };
    const contentViewProps = () => {
      if (view === 'horizontal') {
        return {
          display: 'inline-block'
        };
      }
      return {
        lineHeight: pxToRem(17)
      };
    };
    const ccItemType = (0, _css.css)({
      ...viewProps()
    });
    const ccItemTypeContent = (0, _css.css)({
      ...contentViewProps()
    });
    return {
      ccItemType,
      ccItemTypeContent
    };
  }, [pxToRem, themeColors?.general.light, view]);
  return {
    'cc-Item__type': ccItemTypeStyle.ccItemType,
    'cc-Item__type-content': ccItemTypeStyle.ccItemTypeContent
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;